// In-app payments (Stripe Embedded Checkout, always inside the site).
//
// The publishable key must belong to the same Stripe account as the server's
// STRIPE_SECRET_KEY, or the embedded form fails to load. Which key is used:
//   1. publishableKey returned with each session by the server (Pages env
//      STRIPE_PUBLISHABLE_KEY, set next to STRIPE_SECRET_KEY, no rebuild);
//   2. VITE_STRIPE_PUBLISHABLE_KEY at build time (optional).
// No key is hard-coded: a key baked into the bundle outlives the account it
// belongs to. With neither, the checkout sheet says payments are unavailable.
export const STRIPE_PUBLISHABLE_KEY: string = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || '';
// Buy buttons are on unless a build turns them off (VITE_PAYMENTS_DISABLED=true).
// Whether a payment can actually be taken is the server's call: without keys
// it answers "Payments are not available right now" inside the sheet.
export const paymentsEnabled = import.meta.env.VITE_PAYMENTS_DISABLED !== 'true';

export type ProductKey = 'starter' | 'studio' | 'npc_talk' | 'pass' | 'pro' | 'visionary';

export const PRODUCT_LABELS: Record<ProductKey, { name: string; price: string; blurb: string }> = {
  starter: { name: 'Starter', price: '$9.99', blurb: 'Your first avatar, plus 4 more builds and 6 recolors.' },
  studio: { name: 'Studio pack', price: '$9.99', blurb: '6 Studio credits — about 2 worlds or 3 models.' },
  npc_talk: { name: 'NPC talk pack', price: '$4.99', blurb: '500 talk credits: about 500 standard or 100 premium NPC replies.' },
  pass: { name: 'Founding Pass', price: '$99', blurb: 'Creator Council membership with a monthly AI allowance.' },
  pro: { name: 'Creator Pro', price: '$499', blurb: 'More AI every month, Studio access and creator perks.' },
  visionary: { name: 'Visionary Circle', price: '$2,500', blurb: 'The top Council tier — limited seats.' },
};
